import ServicesForm from "../components/layout/services/ServicesForm";

const ServicesPage = (props) => {
  return <ServicesForm content={props.content} />;
};

export default ServicesPage;
